import { render, staticRenderFns } from "./UseCaseDetails.vue?vue&type=template&id=6334b1ac&scoped=true"
import script from "./UseCaseDetails.vue?vue&type=script&lang=js"
export * from "./UseCaseDetails.vue?vue&type=script&lang=js"
import style0 from "../scss/infoCards.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./UseCaseDetails.vue?vue&type=style&index=1&id=6334b1ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6334b1ac",
  null
  
)

export default component.exports